export enum EPostStatus {
  PUBLISHED = 'PUBLISHED',
  SCHEDULED = 'SCHEDULED',
  DRAFT = 'DRAFT'
}

export const GLOBAL_NEWS_TAG_VALUE = 'GLOBAL_NEWS_TAG_VALUE';
